export default {
	getTemplates: (state) => state.templates,
	getTemplateByName: (state) => (name) => state.templates.find((template) => template.template_name === name),
	getFollowers: (state) => state.followers,
	getFollower: (state) => (followerId) => state.followers.find((follower) => follower.id === followerId),
	getFollowerByEventId: (state) => (eventId) => state.followers.find((follower) => follower.event_id === eventId),
};
